/* En-tête Eliorane : code JavaScript de l'en-tête de Lancaster (sticky-header, header-drawer, mega-menu,
   dropdown-menu, localization-form), repris tel quel puis adapté au minimum :
   - le défilement est celui de la fenêtre ;
   - les éléments personnalisés sont définis une seule fois. */
document.documentElement.classList.add('js');
window.theme = window.theme || {};
theme.config = theme.config || {
  mqlSmall: window.matchMedia('screen and (max-width: 749px)').matches,
  isAppleTouch: /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1),
};
window.matchMedia('screen and (max-width: 749px)').addEventListener('change', (e) => { theme.config.mqlSmall = e.matches; });
const lcScrollY = () => {
  return Math.max(window.pageYOffset || document.documentElement.scrollTop, 0);
};
const lcDefine = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container),
    first = elements[0],
    last = elements[elements.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (event) => {
      (event.target !== container &&
        event.target !== last &&
        event.target !== first) ||
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (event) {
      (event.code ? event.code.toUpperCase() : event.key.toUpperCase()) ===
        'TAB' &&
        (event.target === last &&
          !event.shiftKey &&
          (event.preventDefault(), first.focus({ preventScroll: !0 })),
        (event.target === container || event.target === first) &&
          event.shiftKey &&
          (event.preventDefault(), last.focus({ preventScroll: !0 })));
    }),
    document.addEventListener('focusout', trapFocusHandlers.focusout),
    document.addEventListener('focusin', trapFocusHandlers.focusin),
    elementToFocus && elementToFocus.focus({ preventScroll: !0 }),
    elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value &&
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin),
    document.removeEventListener('focusout', trapFocusHandlers.focusout),
    document.removeEventListener('keydown', trapFocusHandlers.keydown),
    elementToFocus && elementToFocus.focus({ preventScroll: !0 });
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement('span');
    (element.className = 'modal-scrollbar-measure'),
      document.body.appendChild(element);
    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element),
      document.documentElement.style.setProperty(
        '--scrollbar-width',
        `${width}px`,
      );
  }
}

function setHeaderBottomPosition() {
  const header = document.querySelector('.shopify-section-header');
  if (!header) return;
  const announcement = document.querySelector(
      '.shopify-section-announcement-bar',
    ),
    announcementHeight =
      announcement && announcement.offsetParent !== null
        ? announcement.offsetHeight
        : 0;
  setRootPxIfChanged(
    '--header-bottom-position',
    announcementHeight + header.offsetHeight,
  );
}

function parkStickyHeaderForDrawer() {
  if (
    !theme.config.isAppleTouch ||
    ((stickyParkCount += 1), stickyParkCount > 1)
  )
    return;
  const sticky = document.querySelector('sticky-header');
  !sticky ||
    typeof sticky.sticky != 'function' ||
    typeof sticky.reset != 'function' ||
    ((parkedStickyHeader = sticky.sticky()),
    parkedStickyHeader && sticky.reset());
}

function restoreStickyHeaderAfterDrawer() {
  if (
    !theme.config.isAppleTouch ||
    ((stickyParkCount = Math.max(0, stickyParkCount - 1)), stickyParkCount > 0)
  )
    return;
  const wasSticky = parkedStickyHeader;
  if (((parkedStickyHeader = null), !wasSticky)) return;
  const sticky = document.querySelector('sticky-header');
  if (!sticky || typeof sticky.stick != 'function' || !sticky.header) return;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  (typeof sticky.atPageTop == 'function' && sticky.atPageTop(scrollTop)) ||
    sticky.stick();
}

function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}

function setRootPxIfChanged(name, px) {
  const next = Math.round(px);
  if (!Number.isFinite(next) || next < 0) return;
  const current = parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue(name),
  );
  (Number.isFinite(current) && Math.abs(current - next) <= 2) ||
    document.documentElement.style.setProperty(name, `${next}px`);
}

var trapFocusHandlers = {};
let stickyParkCount = 0,
  parkedStickyHeader = null;
class HeaderWrapper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.header = document.querySelector('.shopify-section-header')),
      (this.exitTimer = null),
      (this.onEnterHandler = this.onEnter.bind(this)),
      (this.onLeaveHandler = this.onLeave.bind(this)),
      this.addEventListener('mouseenter', this.onEnterHandler),
      this.addEventListener('mouseleave', this.onLeaveHandler);
  }
  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.onEnterHandler),
      this.removeEventListener('mouseleave', this.onLeaveHandler);
  }
  onEnter() {
    (this.preventClose = !0),
      this.header.classList.add('is-active'),
      clearTimeout(this.exitTimer),
      this.querySelectorAll('mega-menu').forEach((menu) =>
        menu.preloadImages?.(),
      );
  }
  onLeave() {
    this.exitTimer = setTimeout(() => {
      this.header.classList.remove('is-active');
    }, 400);
  }
}
class StickyHeader extends HeaderWrapper {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();
    const initialScrollTop = lcScrollY(),
      initialHeaderBounds = this.header.getBoundingClientRect();
    (this.headerBounds = {
      top: initialScrollTop + initialHeaderBounds.top,
      bottom: initialScrollTop + initialHeaderBounds.bottom,
    }),
      (this.currentScrollTop = initialScrollTop),
      (this.preventReveal = !1),
      (this.scrollUpActive = !1),
      (this.upwardScrollDistance = 0),
      (this.lastScrollDirection = null),
      (this.onScrollHandler = this.onScroll.bind(this)),
      (this.hideHeaderOnScrollUp = () => (this.preventReveal = !0)),
      window.addEventListener('scroll', this.onScrollHandler, !1),
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp),
      this.createObserver();
  }
  disconnectedCallback() {
    super.connectedCallback(),
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp,
      ),
      window.removeEventListener('scroll', this.onScrollHandler),
      this.scrollFrame && cancelAnimationFrame(this.scrollFrame);
  }
  createObserver() {
    new IntersectionObserver((entries, observer2) => {
      if (
        ((this.headerBounds = entries[0].intersectionRect),
        this.headerBounds.top === 0 && this.headerBounds.bottom === 0)
      ) {
        const scrollTop = lcScrollY(),
          boundingClientRect = entries[0].boundingClientRect;
        this.headerBounds = {
          top: scrollTop + boundingClientRect.top,
          bottom: scrollTop + boundingClientRect.bottom,
        };
      }
      this.dataset.scrollUp !== void 0 && (this.scrollUpActive = !0),
        observer2.disconnect();
    }).observe(this.header);
  }
  onScroll() {
    if (
      theme.config.isAppleTouch &&
      (document.body.classList.contains('menu-mobile--open') ||
        document.body.classList.contains('menu-mobile--opening') ||
        document.body.classList.contains('menu-mobile--closing') ||
        document.body.classList.contains('mini-cart--open') ||
        document.body.classList.contains('mini-cart--opening') ||
        document.body.classList.contains('mini-cart--closing') ||
        document.body.classList.contains('search-modal--open') ||
        document.body.classList.contains('facet-drawer--open') ||
        document.body.classList.contains('facet-drawer--opening') ||
        document.body.classList.contains('facet-drawer--closing'))
    )
      return;
    const scrollTop = lcScrollY(),
      scrollDelta = scrollTop - this.currentScrollTop,
      scrollNoiseThreshold = theme.config.mqlSmall ? 2 : 0;
    (!this.atPageTop(scrollTop) &&
      Math.abs(scrollDelta) <= scrollNoiseThreshold) ||
      (theme.config.mqlSmall
        ? this.atPageTop(scrollTop)
          ? ((this.upwardScrollDistance = 0),
            (this.lastScrollDirection = null),
            this.header.classList.contains('shopify-section-header-sticky') &&
              this.requestHeaderState('reset'))
          : this.sticky() ||
            ((this.lastScrollDirection = scrollDelta < 0 ? 'up' : 'down'),
            this.requestHeaderState('stick'))
        : this.scrollUpActive
          ? this.atPageTop(scrollTop)
            ? ((this.upwardScrollDistance = 0),
              (this.lastScrollDirection = null),
              this.requestHeaderState('reset'))
            : scrollDelta > 0
              ? ((this.upwardScrollDistance = 0),
                (this.lastScrollDirection = 'down'),
                scrollTop > this.headerBounds.bottom &&
                  this.requestHeaderState('hide'))
              : scrollDelta < 0 &&
                (this.lastScrollDirection !== 'up' &&
                  (this.upwardScrollDistance = 0),
                (this.lastScrollDirection = 'up'),
                this.preventReveal
                  ? (window.clearTimeout(this.isScrolling),
                    (this.isScrolling = setTimeout(() => {
                      this.preventReveal = !1;
                    }, 66)),
                    this.requestHeaderState('hide'))
                  : ((this.upwardScrollDistance += Math.abs(scrollDelta)),
                    (scrollTop <= this.headerBounds.bottom ||
                      this.upwardScrollDistance > 150 ||
                      this.sticky()) &&
                      this.requestHeaderState(
                        'reveal',
                        () =>
                          this.lastScrollDirection === 'up' || this.sticky(),
                      )))
          : this.atPageTop(scrollTop)
            ? this.requestHeaderState('reset')
            : this.requestHeaderState('stick'),
      (this.currentScrollTop = scrollTop));
  }
  requestHeaderState(state, guard) {
    this.scrollFrame && cancelAnimationFrame(this.scrollFrame),
      (this.scrollFrame = requestAnimationFrame(() => {
        (this.scrollFrame = null), !(guard && !guard()) && this[state]();
      }));
  }
  atPageTop(scrollTop) {
    return theme.config.mqlSmall
      ? scrollTop <= 1
      : scrollTop <= this.topHandoffOffset();
  }
  topHandoffOffset() {
    if (!theme.config.mqlSmall) return 0;
    const announcement = document.querySelector(
      '.shopify-section-announcement-bar',
    );
    return !announcement || announcement.offsetParent === null
      ? 0
      : Math.ceil(
          announcement.getBoundingClientRect().height ||
            announcement.offsetHeight ||
            0,
        );
  }
  hide() {
    if (theme.config.mqlSmall) {
      this.reset();
      return;
    }
    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
    ),
      document.body.classList.add(
        'shopify-body-section-header-hidden',
        'shopify-body-section-header-sticky',
      );
  }
  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate'),
      this.header.classList.remove('shopify-section-header-hidden'),
      document.body.classList.add('shopify-body-section-header-sticky'),
      document.body.classList.remove('shopify-body-section-header-hidden');
  }
  stick() {
    this.header.classList.add('shopify-section-header-sticky'),
      this.header.classList.remove('shopify-section-header-hidden', 'animate'),
      document.body.classList.add('shopify-body-section-header-sticky'),
      document.body.classList.remove('shopify-body-section-header-hidden');
  }
  reset() {
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate',
    ),
      document.body.classList.remove(
        'shopify-body-section-header-hidden',
        'shopify-body-section-header-sticky',
      );
  }
  sticky() {
    return (
      this.header.classList.contains('shopify-section-header-sticky') &&
      !this.header.classList.contains('shopify-section-header-hidden') &&
      document.body.classList.contains('shopify-body-section-header-sticky') &&
      !document.body.classList.contains('shopify-body-section-header-hidden')
    );
  }
}
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.classes = {
        open: 'menu-drawer--open',
        opening: 'menu-drawer--opening',
        closing: 'menu-drawer--closing',
      }),
      (this.animationToken = 0),
      (this.mainDetailsToggle = this.querySelector('details')),
      (this.holdsStickyPark = !1),
      this.addEventListener('keyup', this.onKeyUp.bind(this)),
      this.addEventListener('focusout', this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  disconnectedCallback() {
    this.holdsStickyPark &&
      ((this.holdsStickyPark = !1), restoreStickyHeaderAfterDrawer());
  }
  setClasses(classes) {
    this.classes = classes;
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    ),
      this.querySelectorAll('button[data-close]').forEach((button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this)),
      ),
      this.addEventListener('drawer:force-close', (event) => {
        event.stopPropagation(), this.closeMenuDrawer(event);
      });
  }
  onKeyUp(event) {
    if (
      (event.code ? event.code.toUpperCase() : event.key.toUpperCase()) !==
      'ESCAPE'
    )
      return;
    const openDetailsElement = event.target.closest('details[open]');
    openDetailsElement &&
      (openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            event,
            this.mainDetailsToggle.querySelector('summary'),
          )
        : this.closeSubmenu(openDetailsElement));
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget,
      detailsElement = summaryElement.parentNode,
      isOpen = detailsElement.hasAttribute('open'),
      reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function addTrapFocus() {
      detailsElement.querySelector('button') &&
        trapFocus(
          summaryElement.nextElementSibling,
          detailsElement.querySelector('button'),
        ),
        summaryElement.nextElementSibling.removeEventListener(
          'transitionend',
          addTrapFocus,
        );
    }
    detailsElement === this.mainDetailsToggle
      ? (isOpen && event.preventDefault(),
        isOpen
          ? this.closeMenuDrawer(event, summaryElement)
          : this.openMenuDrawer(summaryElement))
      : setTimeout(() => {
          detailsElement.classList.add('menu-opening'),
            summaryElement.setAttribute('aria-expanded', !0),
            !reducedMotion || reducedMotion.matches
              ? addTrapFocus()
              : summaryElement.nextElementSibling.addEventListener(
                  'transitionend',
                  addTrapFocus,
                );
        }, 100);
  }
  openMenuDrawer(summaryElement = !1) {
    setScrollbarWidth(),
      setHeaderBottomPosition(),
      this.holdsStickyPark ||
        ((this.holdsStickyPark = !0), parkStickyHeaderForDrawer());
    const animationToken = ++this.animationToken;
    summaryElement &&
      (summaryElement.setAttribute('aria-expanded', !0),
      trapFocus(this.mainDetailsToggle, summaryElement)),
      setTimeout(() => {
        animationToken === this.animationToken &&
          ((this.onBodyClickEvent =
            this.onBodyClickEvent || this.onBodyClick.bind(this)),
          document.body.addEventListener('click', this.onBodyClickEvent));
      }),
      this.mainDetailsToggle.classList.remove('menu-closing'),
      document.body.classList.remove(this.classes.closing),
      document.body.classList.add(this.classes.opening),
      this.openAnimation(animationToken),
      setTimeout(() => {
        animationToken === this.animationToken &&
          (this.mainDetailsToggle.setAttribute('open', ''),
          setTimeout(() => {
            animationToken === this.animationToken &&
              this.mainDetailsToggle.classList.add('menu-opening');
          }, 10));
      });
  }
  closeMenuDrawer(event, elementToFocus = !1) {
    if (event !== void 0) {
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open'),
          details.classList.remove('menu-opening');
      }),
        this.mainDetailsToggle.classList.remove('menu-opening'),
        this.mainDetailsToggle.classList.add('menu-closing'),
        removeTrapFocus(elementToFocus),
        document.body.removeEventListener('click', this.onBodyClickEvent);
      const animationToken = ++this.animationToken;
      document.body.classList.remove(this.classes.open, this.classes.opening),
        document.body.classList.add(this.classes.closing),
        this.closeAnimation(this.mainDetailsToggle, animationToken),
        this.dispatchEvent(new CustomEvent('close')),
        document.dispatchEvent(new CustomEvent('menudrawer:close'));
    }
  }
  onFocusOut() {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    const target = event.currentTarget;
    if (target.classList.contains('noclose')) return;
    const detailsElement = target.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening'),
      detailsElement.querySelector('summary').setAttribute('aria-expanded', !1),
      removeTrapFocus(),
      this.closeAnimation(detailsElement);
  }
  openAnimation(animationToken) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationToken !== this.animationToken) return;
      if (
        (animationStart === void 0 && (animationStart = time),
        time - animationStart < 400)
      )
        window.requestAnimationFrame(handleAnimation);
      else {
        if (animationToken !== this.animationToken) return;
        document.body.classList.remove(this.classes.opening),
          this.mainDetailsToggle.hasAttribute('open') &&
            !this.mainDetailsToggle.classList.contains('menu-closing') &&
            document.body.classList.add(this.classes.open);
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
  closeAnimation(detailsElement, animationToken = null) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationToken !== null && animationToken !== this.animationToken)
        return;
      if (
        (animationStart === void 0 && (animationStart = time),
        time - animationStart < 400)
      )
        window.requestAnimationFrame(handleAnimation);
      else {
        if (detailsElement === this.mainDetailsToggle) {
          if (animationToken !== null && animationToken !== this.animationToken)
            return;
          document.body.classList.remove(
            this.classes.open,
            this.classes.opening,
            this.classes.closing,
          ),
            detailsElement.classList.remove('menu-closing'),
            this.holdsStickyPark &&
              ((this.holdsStickyPark = !1), restoreStickyHeaderAfterDrawer());
        }
        detailsElement.removeAttribute('open'),
          detailsElement.closest('details[open]') &&
            trapFocus(
              detailsElement.closest('details[open]'),
              detailsElement.querySelector('summary'),
            );
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
  onBodyClick(event) {
    this.contains(event.target) || this.closeMenuDrawer(event);
  }
}
class HeaderDrawer extends MenuDrawer {
  openMenuDrawer(summaryElement = !1) {
    this.querySelectorAll('details[data-default-open]').forEach((details) => {
      (details.open = !0),
        details.classList.add('menu-opening'),
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    }),
      super.openMenuDrawer(summaryElement);
  }
  constructor() {
    super(),
      this.setClasses({
        open: 'menu-mobile--open',
        opening: 'menu-mobile--opening',
        closing: 'menu-mobile--closing',
      });
  }
}
class DrawerCloseButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener('click', () =>
        this.dispatchEvent(
          new CustomEvent('drawer:force-close', {
            bubbles: !0,
            cancelable: !0,
            composed: !0,
          }),
        ),
      );
  }
}
class HeaderMenuToggle extends HTMLElement {
  constructor() {
    super(),
      (this.header = document.querySelector('.shopify-section-header')),
      this.addEventListener('click', this.onButtonClick.bind(this));
  }
  onButtonClick() {
    this.header.classList.toggle('shopify-section-header-menu-open');
  }
}
class LocalizationForm extends HTMLElement {
  constructor() {
    super(),
      (this.elements = {
        input: this.querySelector(
          'input[name="locale_code"], input[name="language_code"], input[name="country_code"]',
        ),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      }),
      this.elements.button.addEventListener(
        'click',
        this.openSelector.bind(this),
      ),
      this.elements.button.addEventListener(
        'focusout',
        this.closeSelector.bind(this),
      ),
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this)),
      this.querySelectorAll('a').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this)),
      );
  }
  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false'),
      this.elements.panel.setAttribute('hidden', !0),
      this.classList.contains('on-header') &&
        document.body.classList.remove('localization--open');
  }
  onContainerKeyUp(event) {
    event.code.toUpperCase() === 'ESCAPE' && this.hidePanel();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    (this.elements.input.value = event.currentTarget.dataset.value),
      form && form.submit();
  }
  openSelector() {
    this.elements.panel.toggleAttribute('hidden'),
      this.elements.button.setAttribute(
        'aria-expanded',
        (
          this.elements.button.getAttribute('aria-expanded') === 'false'
        ).toString(),
      ),
      this.classList.contains('on-header') &&
        document.body.classList.toggle('localization--open');
  }
  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    (event.relatedTarget === null || shouldClose) && this.hidePanel();
  }
}
class DropdownMenu extends HTMLElement {
  constructor() {
    super(),
      (this.classes = {
        hover: 'is-hover',
        active: 'is-active',
        animate: 'show-from-bottom',
      }),
      (this.selectors = {
        header: '.shopify-section-header',
        background: '.header-background',
        topMenuItem: '.header__menu-item--top',
        menus: 'dropdown-menu, mega-menu',
        wrapper: '.list-menu',
        childAnimate: '.list-menu-dropdown > .list-menu',
      }),
      this.timeout,
      this.addEventListener('focusin', this.handleMouseover.bind(this)),
      this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }
  handleMouseover() {
    this.classList.contains(this.classes.active) ||
      (this.bindEvent(),
      this.removeClasses(),
      this.addClasses(),
      this.resetBackground(),
      this.animateMenu());
  }
  handleMouseleave() {
    this.header &&
      (this.reset(),
      this.resetBackground(),
      this.header.classList.remove(this.classes.hover),
      this.wrapper.removeEventListener(
        'mouseleave',
        this.onHeaderMouseLeaveEvent,
      ));
  }
  bindEvent() {
    (this.onHeaderMouseLeaveEvent =
      this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this)),
      (this.header =
        this.header || document.querySelector(this.selectors.header)),
      (this.wrapper = this.closest(this.selectors.wrapper)),
      this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }
  addClasses() {
    const isTopLevel = this.querySelector(this.selectors.topMenuItem);
    let delay = 0;
    isTopLevel &&
      !this.isHover() &&
      ((delay = 150),
      (this.closest('.header--top-center') ||
        this.closest('.header--top-left')) &&
        (delay = 200)),
      (this.timeout = setTimeout(() => {
        this.isHover() && this.classList.add(this.classes.active);
      }, delay)),
      this.header.classList.add(this.classes.hover);
  }
  removeClasses() {
    this.header.querySelectorAll(this.selectors.menus).forEach((menu) => {
      let found = !1;
      menu.querySelectorAll('dropdown-menu').forEach((element) => {
        if (element === this) {
          found = !0;
          return;
        }
      }),
        found || menu.reset();
    });
  }
  isHover() {
    return this.header.classList.contains(this.classes.hover);
  }
  reset() {
    this.classList.remove(this.classes.active);
    const childAnimate = this.querySelector(this.selectors.childAnimate);
    childAnimate && childAnimate.classList.remove(this.classes.animate),
      clearTimeout(this.timeout);
  }
  resetBackground() {
    this.header
      .querySelector(this.selectors.background)
      .classList.remove(this.classes.active);
  }
  animateMenu() {
    const childAnimate = this.querySelector(this.selectors.childAnimate);
    childAnimate &&
      setTimeout(() => {
        childAnimate.classList.add(this.classes.animate);
      }, 150);
  }
  close() {
    this.handleMouseleave();
  }
}
class MegaMenu extends HTMLElement {
  constructor() {
    super(),
      (this.classes = {
        hover: 'is-hover',
        active: 'is-active',
        animate: 'show-from-bottom',
      }),
      (this.selectors = {
        header: '.shopify-section-header',
        background: '.header-background',
        dropdown: '.list-menu-dropdown',
        topMenuItem: '.header__menu-item--top',
        menus: 'dropdown-menu, mega-menu',
        wrapper: '.list-menu',
        childAnimate: '.mega-menu__item, .mega-menu__promo',
      }),
      (this.timeout = []),
      this.addEventListener('focusin', this.handleMouseover.bind(this)),
      this.addEventListener('mouseenter', this.handleMouseover.bind(this)),
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) {
          this.handleMouseleave();
        }
      }),
      this.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          this.handleMouseleave();
          const topLink = this.querySelector(this.selectors.topMenuItem);
          topLink && topLink.focus();
        }
      });
  }
  handleMouseover() {
    this.classList.contains(this.classes.active) ||
      (this.renderPanel(),
      this.bindEvent(),
      this.removeClasses(),
      this.addClasses(),
      this.showSublist());
  }
  renderPanel() {
    const template = this.querySelector(
      ':scope > .list-menu-dropdown > template',
    );
    template && template.replaceWith(template.content);
  }
  preloadImages() {
    if (this.imagesPreloaded || !this.offsetParent) return;
    this.imagesPreloaded = !0;
    const template = this.querySelector(
      ':scope > .list-menu-dropdown > template',
    );
    template &&
      template.content.querySelectorAll('img[srcset]').forEach((img) => {
        const image = new Image();
        ['sizes', 'srcset', 'src'].forEach((name) => {
          img.hasAttribute(name) &&
            image.setAttribute(name, img.getAttribute(name));
        });
      });
  }
  handleMouseleave() {
    this.header &&
      (this.reset(),
      this.resetBackground(),
      this.header.classList.remove(this.classes.hover),
      this.wrapper.removeEventListener(
        'mouseleave',
        this.onHeaderMouseLeaveEvent,
      ));
  }
  bindEvent() {
    (this.onHeaderMouseLeaveEvent =
      this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this)),
      (this.header =
        this.header || document.querySelector(this.selectors.header)),
      (this.wrapper = this.closest(this.selectors.wrapper)),
      this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }
  showSublist() {
    const dropdown = this.querySelector(this.selectors.dropdown),
      background = this.header.querySelector(this.selectors.background),
      headerHeight =
        this.header.querySelector('.header')?.clientHeight ||
        this.header.clientHeight;
    background.style.setProperty('--offset', headerHeight + 'px'),
      background.style.setProperty('--height', dropdown.clientHeight + 'px'),
      background.classList.add(this.classes.active);
  }
  addClasses() {
    this.classList.add(this.classes.active);
    const childAnimate = this.querySelectorAll(this.selectors.childAnimate),
      delay = childAnimate.length > 5 ? 75 : 150;
    childAnimate.forEach((element, index) => {
      const timeout = setTimeout(
        () => {
          element.classList.add(this.classes.animate);
        },
        delay * index + 100,
      );
      this.timeout.push(timeout);
    }),
      this.header.classList.add(this.classes.hover);
  }
  removeClasses() {
    this.header.querySelectorAll(this.selectors.menus).forEach((menu) => {
      menu.reset();
    });
  }
  reset() {
    this.classList.remove(this.classes.active),
      this.querySelectorAll(this.selectors.childAnimate).forEach((element) => {
        element.classList.remove(this.classes.animate);
      }),
      this.timeout.forEach((timeout) => {
        clearTimeout(timeout);
      });
  }
  resetBackground() {
    this.header
      .querySelector(this.selectors.background)
      .classList.remove(this.classes.active);
  }
  close() {
    this.handleMouseleave();
  }
}
lcDefine('header-wrapper', HeaderWrapper);
lcDefine('sticky-header', StickyHeader);
lcDefine('drawer-close-button', DrawerCloseButton);
lcDefine('menu-drawer', MenuDrawer);
lcDefine('header-drawer', HeaderDrawer);
lcDefine('header-menu-toggle', HeaderMenuToggle);
lcDefine('localization-form', LocalizationForm);
lcDefine('dropdown-menu', DropdownMenu);
lcDefine('mega-menu', MegaMenu);
